import { request } from "./request";
// 判断官网和HR端当前环境  员工体检接口地址
let learnApi = function () {
    if (document.domain.includes("ers-welfare-mall.test-01.54test.cn")) {
        return "https://api.ers-courselearning.test-01.54test.cn";
    } else if(document.domain.startsWith("mall.1renshi.com")) {
        return "https://api.courselearning.1renshi.com";
    } else {
        return "https://api.ers-courselearning.test-01.54test.cn";
    }
}()

//获取 课程分类
export const getShopCategoryList=()=>request({
    method:'get',
    url:`${learnApi}/CourseLearning/SupplierCourseCategory/ShopCategoryList`
})
//获取 细分类目
export const getShopSubCategoryList=(params)=>request({
    method:'get',
    url:`${learnApi}/CourseLearning/SupplierCourseCategory/ShopSubCategoryList`,
    params
})

// 获取 商城最新上架 指定上架 课程
export const getNewCourseList=(params)=>request({
    method:'get',
    url:`${learnApi}/CourseLearning/Meal/Shop/GetNewCourseList`,
    params
})

// 获取商城免费上架课程
export const getFreeCourseList=(params)=>request({
    method:'get',
    url:`${learnApi}/CourseLearning/Meal/Shop/GetFreeCourseList`,
    params
})

// 获取商城课程列表
export const getCourseList=(params)=>request({
    method:'get',
    url:`${learnApi}/CourseLearning/Meal/Shop/GeCourseList`,
    params
})

//获取 课程详情
export const getCourseInfo=(params)=>request({
    method:'get',
    url:`${learnApi}/CourseLearning/Meal/Shop/GeCourseInfo`,
    params
})

//获取 购物车
export const getCourseCart=()=>request({
    method:'get',
    url:`${learnApi}/CourseLearning/Meal/Shop/GetMyCart`
})
//添加 购物车
export const AddCourseCart=(data)=>request({
    method:'post',
    url:`${learnApi}/CourseLearning/Meal/Shop/AddMyCart`,
    data
})
//添加 购物车 此接口登录那一刻只调用一次
export const getCourseReqAddCart=(data)=>request({
    method:'post',
    url:`${learnApi}/CourseLearning/Meal/Shop/AddMyCart`,
    data
})
//修改 购物车数据
export const CourseCountChange=(cartId,quantity)=>request({
    method:'get',
    url:`${learnApi}/CourseLearning/Meal/Shop/MyCart/CountChange?cartId=${cartId}&quantity=${quantity}`,
})
//删除 购物车
export const DeleteCourseCart=(cartId)=>request({
    method:'delete',
    url:`${learnApi}/CourseLearning/Meal/Shop/DeleteMyCart?cartId=${cartId}`,
})
//提交 购物车
export const AddLearnOrder=(data)=>request({
    method:'post',
    url:`${learnApi}/CourseLearning/Order/AddOrder`,
    data
})